// extracted by mini-css-extract-plugin
export default {"ButtonWrapper":"ThirdLevelNavigation_ButtonWrapper__uvhhL","RedAlertContainer":"ThirdLevelNavigation_RedAlertContainer__8Je5y","CustomBox":"ThirdLevelNavigation_CustomBox__bk-12"};